import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "contact-section" }
const _hoisted_2 = { class: "jumbotron jumbotron-fluid bg-1 m-0" }
const _hoisted_3 = { class: "container hero-text" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 text-center" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "social_container m-3" }
const _hoisted_11 = { class: "social_container m-3" }
const _hoisted_12 = { class: "social_container m-3" }
const _hoisted_13 = { class: "social_container m-3" }
const _hoisted_14 = { class: "social_container m-3" }
const _hoisted_15 = { class: "social_container m-3" }
const _hoisted_16 = { class: "social_container m-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-12 text-center" }, [
            _createElementVNode("h2", { class: "headtxt" }, "Contact")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("hr", { class: "sethr" }, null, -1)
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-mobile",
                    class: "me-1"
                  }),
                  _cache[1] || (_cache[1] = _createTextVNode(" : ")),
                  _cache[2] || (_cache[2] = _createElementVNode("a", { href: "tel:+66894705387" }, "0894705387", -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-envelope" }),
                  _cache[3] || (_cache[3] = _createTextVNode(" : ")),
                  _cache[4] || (_cache[4] = _createElementVNode("a", { href: "mailto:p.kittichet@gmail.com" }, "p.kittichet@gmail.com", -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-facebook" }),
                  _cache[5] || (_cache[5] = _createTextVNode(" : ")),
                  _cache[6] || (_cache[6] = _createElementVNode("a", {
                    target: "_blank",
                    href: "https://www.facebook.com/deathwing.tei"
                  }, "Facebook", -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_font_awesome_icon, { icon: "fab fa-linkedin-in" }),
                  _cache[7] || (_cache[7] = _createTextVNode(" : ")),
                  _cache[8] || (_cache[8] = _createElementVNode("a", {
                    target: "_blank",
                    href: "https://www.linkedin.com/in/kittichet-Puengreang-b7832989/"
                  }, "Linkin", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-line" }),
                  _cache[9] || (_cache[9] = _createTextVNode(" : ")),
                  _cache[10] || (_cache[10] = _createElementVNode("a", {
                    target: "_blank",
                    href: "https://line.me/ti/p/I_QfAkbbz4?fbclid=IwAR0Bdk3rlDeAQgZjzc8OoDYoGJSHbuLjEjJbzo2i5yMKuswaSCZbaktekT0"
                  }, "Line", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-github" }),
                  _cache[11] || (_cache[11] = _createTextVNode(" : ")),
                  _cache[12] || (_cache[12] = _createElementVNode("a", {
                    target: "_blank",
                    href: "https://github.com/deathwingtei"
                  }, "GitHub", -1))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-bandcamp" }),
                  _cache[14] || (_cache[14] = _createTextVNode(" : ")),
                  _createVNode(_component_router_link, { to: "/certificate" }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Certificate")
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}